module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-48x48-7019607737fea60384ce3fc813c4f027.png";